import axios from "axios";
import QS from "qs";

// 环境切换
if (process.env.NODE_ENV == "development") {
  // 开发地址
  // axios.defaults.baseURL = "http://192.168.1.6:8080/";
	axios.defaults.baseURL = "https://api.slkjkg.com/prod-api/";

} else if (process.env.NODE_ENV == "production") {
  // 正式地址
  axios.defaults.baseURL = "https://api.slkjkg.com/prod-api/";
}

// 设置超时时间
axios.defaults.timeout = 10000;

// post 请求头
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";

// 请求拦截器
axios.interceptors.request.use(
  config => {
    // const token = store.state.token;
    // token && (config.headers.Authorization = token);
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码 不是 200 的情况
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        case 404:
          alert("请求不存在");
          break;
        // 其他错误
        default:
          alert("其他错误");
          break;
      }
    }
    return Promise.reject(error.response);
  }
);

// 请求封装 ---- get
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}

//
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params,
	  {
	    headers: {
	      'Content-Type': 'application/json;',
	    }
	  })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}



// WEBPACK FOOTER //
// ./src/utils/requrest.js